// extracted by mini-css-extract-plugin
export var active = "index-module--active--oPdtj";
export var dot = "index-module--dot--LWm-k";
export var indicator = "index-module--indicator--+V9TZ";